<template>
    <div class='h100vh-150 h-normalBg'>
        <div class='h-ainfoBg'>
            <div class='h-ainfo'>
                <span class='icon hero-icon hero-icon-detailcode'></span>
                <span>{{$t('Monitor.realTimeMonitoring.diskSize')}}： {{ diskSize }}GB</span>
                <span>{{$t('Monitor.realTimeMonitoring.diskUsage')}}： {{ diskUsage }}GB</span>
                <span>{{$t('Monitor.realTimeMonitoring.diskUtilization')}}： {{ diskUtilization }}%</span>
            </div>
        </div>
        <div class='h-normalContainter'>
                <div class='row h-nomargin h-full-container width-100vw h100-80'>
                    <div id='diskMonitor' class='width-100vw h100' style="height:599px"></div>
                </div>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts';

export default{
    name: "realtimeMemoryMonitor",
    data() {
        return {
          data: [],
          charts: "",
          app: {},
          myChart: null,
          xData: [],
          diskSize: 0,
          diskUsage: 0,
          diskUtilization: 0,
        };
    },
    methods: {
        initData() {
            this.myChart = echarts.init(document.getElementById('diskMonitor'));
            for (var i=0;i<12;i++){
                if(i==11){
                    this.xData.push('0');
                }else if (i==0){
                    this.xData.push('60s')
                }else{
                    this.xData.push('');
                }
                this.data.push('-');
            }
            let option = this.getChartOption();
            if (option && typeof option === 'object') {
                this.myChart.setOption(option);
            }
            this.getMonitorData();
        },
        random(min,max){
            return Math.floor(Math.random()*(max-min))+min;
        },
        randomData() {
            return this.random(5600,7000);
        },
        getMonitorData(diskSize, diskUsage, diskUtilization) {
          this.diskSize = diskSize;
          this.diskUsage = diskUsage;
          this.diskUtilization = diskUtilization;
          if(this.data.length >= 12){
            this.data.shift();
          }
          this.data.push(diskUsage);
          this.myChart.clear();
          this.myChart.setOption(this.getChartOption(),true);
          this.myChart.resize();
        },
        getChartOption() {
            const option = {
                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: function (params) {
                    return params[0].value;
                    },
                    axisPointer: {
                    animation: false
                    }
                },
                xAxis: {
                    type: 'category',
                    data: this.xData,
                    boundaryGap: false
                },
                yAxis: {
                    name: "GB",
                    type: 'value',
                    axisLabel: {
                        formatter: '{value}'
                    }
                },
                series: [
                    {
                        type: 'line',
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: 'rgb(220,236,203)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgb(196,228,172)'
                                    }
                                ],
                                global: false
                            }
                        },
                        data: this.data,
                        lineStyle: {
                            color: '#4da40d'
                        }
                    }
                ]
            };
            return option;
        }
    },
    mounted() {
        this.initData();
    },
    beforeDestroy() {
        try {
            clearInterval(this.clock);
        } catch (e) {
            console.log(e);
        }
    }
}
</script>
